// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../action-list';

const updateGoodsInstallationVatOptions = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_GOODS_INSTALLATION_VAT_OPTIONS]: updateGoodsInstallationVatOptions
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/shared/reducers/goods-installation-vat-options.js